//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { RIGHTS_STATUS } from '@apis/rights-management/rightsManagementApiModels';

export const checkIsStatusInitiated = (status: RIGHTS_STATUS | undefined) =>
  status === RIGHTS_STATUS.INITIATED ||
  status === RIGHTS_STATUS.PENDING ||
  status === RIGHTS_STATUS.EXPIRED ||
  status === RIGHTS_STATUS.APPROVED;

export const checkIsStatusPendingOrFinalized = (
  status: RIGHTS_STATUS | undefined,
) =>
  checkIsStatusInitiated(status) ||
  status === RIGHTS_STATUS.QUEUED ||
  status === RIGHTS_STATUS.FAILED_TO_SEND;
